// extracted by mini-css-extract-plugin
export default {"main":"NotFound_main__IBAJM","page_not_found":"NotFound_page_not_found__U4n-6","instructions":"NotFound_instructions__R31+G"};